import { useContext } from 'react';
import { createNamedContext } from '@utils';
import { UTM } from '@/types';

export const UTMParametersContext = createNamedContext<UTM>(null, 'UTMParametersContext');

export const useUTMParameters = () => useContext(UTMParametersContext);